import * as React from 'react';

export const CoinsLineIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <ellipse cx='12.5444' cy='13.0559' rx='5.26316' ry='3.88889' fill='white' />
    <path
      d='M12.5444 8.61133C15.7417 8.61133 18.3338 10.1036 18.3338 11.9447V14.1669C18.3338 16.008 15.7417 17.5002 12.5444 17.5002C9.40383 17.5002 6.84751 16.0608 6.75751 14.2652L6.75488 14.1669V11.9447C6.75488 10.1036 9.34699 8.61133 12.5444 8.61133ZM12.5444 15.278C10.5865 15.278 8.85488 14.7186 7.80751 13.8613V14.1669C7.80751 15.2124 9.8512 16.3891 12.5444 16.3891C15.1812 16.3891 17.1959 15.2613 17.2786 14.2324L17.2812 14.1669L17.2817 13.8613C16.2344 14.718 14.5028 15.278 12.5444 15.278ZM12.5444 9.72244C9.8512 9.72244 7.80751 10.8991 7.80751 11.9447C7.80751 12.9902 9.8512 14.1669 12.5444 14.1669C15.2375 14.1669 17.2812 12.9902 17.2812 11.9447C17.2812 10.8991 15.2375 9.72244 12.5444 9.72244Z'
      fill='#007191'
    />
    <path d='M9.91309 14.7227V16.1115' stroke='#007191' />
    <path d='M11.4922 14.7227L11.4922 16.9449' stroke='#007191' />
    <path d='M13.5967 14.7227L13.5967 16.9449' stroke='#007191' />
    <path d='M15.1758 14.167L15.1758 16.3892' stroke='#007191' />
    <path d='M16.7549 13.6113L16.7549 15.8336' stroke='#007191' />
    <path d='M8.33398 13.6113L8.33398 15.8336' stroke='#007191' />
    <ellipse cx='6.62253' cy='10.278' rx='5.26316' ry='3.88889' fill='white' />
    <path
      d='M6.62248 5.8335C9.81985 5.8335 12.412 7.32572 12.412 9.16683V11.3891C12.412 13.2302 9.81985 14.7224 6.62248 14.7224C3.48196 14.7224 0.925639 13.2829 0.835639 11.4874L0.833008 11.3891V9.16683C0.833008 7.32572 3.42511 5.8335 6.62248 5.8335ZM6.62248 12.5002C4.66459 12.5002 2.93301 11.9407 1.88564 11.0835V11.3891C1.88564 12.4346 3.92932 13.6113 6.62248 13.6113C9.25932 13.6113 11.2741 12.4835 11.3567 11.4546L11.3593 11.3891L11.3598 11.0835C10.3125 11.9402 8.5809 12.5002 6.62248 12.5002ZM6.62248 6.94461C3.92932 6.94461 1.88564 8.12127 1.88564 9.16683C1.88564 10.2124 3.92932 11.3891 6.62248 11.3891C9.31564 11.3891 11.3593 10.2124 11.3593 9.16683C11.3593 8.12127 9.31564 6.94461 6.62248 6.94461Z'
      fill='#007191'
    />
    <path d='M3.99121 11.667V13.0559' stroke='#007191' />
    <path d='M5.57031 11.667L5.57031 13.8892' stroke='#007191' />
    <path d='M7.6748 11.667L7.6748 13.8892' stroke='#007191' />
    <path d='M9.25391 11.1113L9.25391 13.3336' stroke='#007191' />
    <path d='M10.833 10.5557L10.833 12.7779' stroke='#007191' />
    <path d='M2.41211 10.5557L2.41211 12.7779' stroke='#007191' />
    <ellipse cx='9.12253' cy='6.11106' rx='5.26316' ry='3.88889' fill='white' />
    <path
      d='M9.12248 1.6665C12.3198 1.6665 14.912 3.15873 14.912 4.99984V7.22206C14.912 9.06317 12.3198 10.5554 9.12248 10.5554C5.98196 10.5554 3.42564 9.11595 3.33564 7.32039L3.33301 7.22206V4.99984C3.33301 3.15873 5.92511 1.6665 9.12248 1.6665ZM9.12248 8.33317C7.16459 8.33317 5.43301 7.77373 4.38564 6.9165V7.22206C4.38564 8.26762 6.42932 9.44428 9.12248 9.44428C11.7593 9.44428 13.7741 8.3165 13.8567 7.28762L13.8593 7.22206L13.8598 6.9165C12.8125 7.77317 11.0809 8.33317 9.12248 8.33317ZM9.12248 2.77762C6.42932 2.77762 4.38564 3.95428 4.38564 4.99984C4.38564 6.04539 6.42932 7.22206 9.12248 7.22206C11.8156 7.22206 13.8593 6.04539 13.8593 4.99984C13.8593 3.95428 11.8156 2.77762 9.12248 2.77762Z'
      fill='#007191'
    />
    <path d='M6.49121 7.77783V9.16672' stroke='#007191' />
    <path d='M8.07031 7.77783L8.07031 10.0001' stroke='#007191' />
    <path d='M10.1748 7.77783L10.1748 10.0001' stroke='#007191' />
    <path d='M11.7539 7.22217L11.7539 9.44439' stroke='#007191' />
    <path d='M13.333 6.6665L13.333 8.88873' stroke='#007191' />
    <path d='M4.91211 6.6665L4.91211 8.88873' stroke='#007191' />
  </svg>
);
